import { createAction, props } from '@ngrx/store';
import { OrgStaffUserInterfaceWithId } from '@sk/sk-interfaces';


export const getCurrentUser = createAction('[Current User] Get Current User');

export const getCurrentUserSuccess = createAction('[Current User] Get Current User Success',
  props<{ currentUser: OrgStaffUserInterfaceWithId }>()
);
export const getCurrentUserError = createAction('[Current User] Get Current User Error',
  props<{ error: any }>()
);

// FIRESTORE //
export const getFireStoreCurrentUser = createAction(
  '[Current User] get Current User from Firestore',
  props<{ organizationUserId : string }>()
);


export const fromFireStoreCurrentUserError = createAction(
  '[Current User] error at get Current User From FireStore',
  props<{ error: Error }>()
);

export const fromFireStoreAddCurrentUser = createAction(
  '[Current User] Current User added by Firestore',
  props<{ user: OrgStaffUserInterfaceWithId }>()
);




